import { storeToRefs } from 'pinia'
import { useVKConnectStore } from '@academica-box/composables/store/VKConnect'
import type { PaymentFormData } from '@academica-box/types'
import { useLandingStore } from '@/store/landing'

export const useAnalytics = () => {
  const { $api, $sentry } = useNuxtApp()
  const landingStore = useLandingStore()
  const { landing, requestId } = storeToRefs(landingStore)
  const VKConnectStore = useVKConnectStore()
  const { userData } = storeToRefs(VKConnectStore)

  const clUid = useCookie<string>('x_cl_uid')
  const utmSource = useCookie<string>('x_utm_source')

  return {
    tryEdpartnersPayment: (model: PaymentFormData) => {
      if (utmSource.value === 'edpartners') {
        $api.marketing.sendData({
          click_id: clUid.value,
          goal: 1,
          price: landing?.value?.courseCardBlock?.card.price.current,
          action_id: requestId?.value || '',
          email: model.email,
          course_name: landing?.value?.startScreenBlock?.title || '',
        }).catch((error) => {
          $sentry.captureException(error)
        })
      }
    },
    tryEdpartnersOrder: (model: PaymentFormData, goal: 1 | 2 | 3) => {
      if (utmSource.value === 'edpartners') {
        $api.marketing.sendData({
          click_id: clUid.value,
          goal,
          action_id: requestId?.value || '',
          email: model.email,
          course_name: landing?.value?.startScreenBlock?.title || '',
        }).catch((error) => {
          $sentry.captureException(error)
        })
      }
    },
    moreSlov: () => {
      const isMoreSlovGame = useCookie('more_slov')

      if (isMoreSlovGame.value && userData?.value?.vkID) {
        $api.vk.sendVkGameData({
          user_id: userData?.value?.vkID,
          task_id: 8922, // айди игры "море слов"
          request_id: requestId?.value || '',
        }).then(() => {
          isMoreSlovGame.value = undefined
        }).catch((error) => {
          $sentry.captureException(error)
        })
      }
    }
  }
}
